namespace GeniuzPOS.Supplier {
    export interface CsSupplierForm {
        SupplId: Serenity.StringEditor;
        SupplType: Serenity.LookupEditor;
        SupplName: Serenity.StringEditor;
        SupplierShortName: Serenity.StringEditor;
        ContactName: Serenity.StringEditor;
        SupTelNo: Serenity.StringEditor;
        TelNoExt: Serenity.StringEditor;
        SupEmail: Serenity.StringEditor;
        SupplAddress: Serenity.TextAreaEditor;
        Remark: Serenity.TextAreaEditor;
        SupplRegName: Serenity.StringEditor;
        BranchCode: Serenity.StringEditor;
        BranchName: Serenity.StringEditor;
        SupplRegAddress: Serenity.TextAreaEditor;
        SupplTaxId: Serenity.StringEditor;
        ConsignFg: Serenity.BooleanEditor;
        ConsignGp: Serenity.DecimalEditor;
        ReturnOutRemark: Serenity.TextAreaEditor;
    }

    export class CsSupplierForm extends Serenity.PrefixedContext {
        static formKey = 'Supplier.CsSupplier';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsSupplierForm.init)  {
                CsSupplierForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.TextAreaEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(CsSupplierForm, [
                    'SupplId', w0,
                    'SupplType', w1,
                    'SupplName', w0,
                    'SupplierShortName', w0,
                    'ContactName', w0,
                    'SupTelNo', w0,
                    'TelNoExt', w0,
                    'SupEmail', w0,
                    'SupplAddress', w2,
                    'Remark', w2,
                    'SupplRegName', w0,
                    'BranchCode', w0,
                    'BranchName', w0,
                    'SupplRegAddress', w2,
                    'SupplTaxId', w0,
                    'ConsignFg', w3,
                    'ConsignGp', w4,
                    'ReturnOutRemark', w2
                ]);
            }
        }
    }
}
